<template>
  <div>
    <zb-modal
      ref="mobileBookingModal"
      class="slide-in-modal text-center"
      :no-padding="true"
      :class="{ 'pull-top-0': hasFullInfo }"
      :is-full-screen="true"
      :show-close-icon="false"
      @close="handleClose"
    >
      <template #title="{ modal }">
        <div class="title-block mb-6">
          <picker-header @close="modal.hide" />
        </div>
      </template>

      <template v-slot:default>
        <div class="container-md-400 mx-auto lh-150">
          <date-picker
            class="sm:px-6"
            v-show="hasMissingDate || forceShowDatePicker"
          />
          <guest-picker
            class="sm:px-6"
            v-show="hasMissingGuests || forceShowGuestsPicker"
          />
          <booking-summary
            v-show="
              hasFullInfo && !forceShowDatePicker && !forceShowGuestsPicker
            "
          >
            <template #supplier>
              <slot name="supplier" />
            </template>

            <template #policies>
              <slot name="policies" />
            </template>
          </booking-summary>
        </div>
      </template>
    </zb-modal>
  </div>
</template>

<script>
import BookingSummary from "./Mobile/BookingSummary";
import ZbModal from "../core/ZbModal";
import { mapState } from "vuex";
import DatePicker from "./Mobile/DatePicker";
import GuestPicker from "./Mobile/GuestPicker";
import Header from "./Mobile/Header.vue";

export default {
  components: {
    ZbModal,
    BookingSummary,
    DatePicker,
    GuestPicker,
    "picker-header": Header,
  },
  computed: {
    ...mapState([
      "isShowingMobileBooking",
      "formData",
      "forceShowDatePicker",
      "forceShowGuestsPicker",
    ]),
    hasMissingDate() {
      return this.formData.date === null;
    },
    hasMissingGuests() {
      return this.formData.guests === "0";
    },
    hasFullInfo() {
      return !this.hasMissingDate && !this.hasMissingGuests;
    },
    extraContainerClass() {
      if (this.hasFullInfo) {
        return "px-6 w-full";
      } else {
        return "container-md-400";
      }
    },
  },
  methods: {
    handleClose() {
      this.$store.commit("setIsShowingMobileBooking", false);
    },
  },
  watch: {
    isShowingMobileBooking(value) {
      if (value) {
        this.$refs.mobileBookingModal.show();
      }
    },
  },
};
</script>

<style scoped>
.title-block {
  border-bottom: 1px solid var(--black-light-2);
  padding-bottom: 24px;
  margin-left: -24px;
  margin-right: -24px;
}

aside.zb-modal.slide-in-modal.active.pull-top-0 {
  top: 0px !important;
}

@media (min-width: 601px) and (max-width: 1200px) {
  .title-block {
    padding-top: 24px;
    margin-left: 0px;
    margin-right: 0px;
    padding-left: 24px;
    padding-right: 24px;
  }
}

@media (max-width: 600px) {
  .title-block {
    margin-left: 0px;
    margin-right: 0px;
    padding: 24px;
  }
}
</style>
